import { z, type ZodType } from "zod/v4";

/**
 * Returns a Zod schema for a collection of items returned by Passage API.
 *
 * @template TItem Type of the items in the collection.
 * @param {ZodType<TItem>} itemSchema - Schema for the items in the collection.
 * @returns Collection schema
 */
export const schema = <TItem>(itemSchema: ZodType<TItem>) =>
    z.object({
        result: z.array(itemSchema),
        count: z.number().int().min(0),
    });

/**
 * Type for a collection of items returned by Passage API.
 */
export type PassageCollection<TItem> = z.infer<
    ReturnType<typeof schema<TItem>>
>;
